import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UserJoinOrgComponent } from './user-join-org/user-join-org.component';
import { UserPreferencesComponent } from './user-preferences/user-preferences.component';
import { AuiUserAuthenticatedGuard, AuiUserRegisteredGuard } from '@angeltrax/ngx-aui';
import type { AuiRoutes } from '@angeltrax/ngx-aui';

export const routes: AuiRoutes = [
  {
    path: 'users',
    children: [
      { path: '',
        pathMatch: 'full',
        redirectTo: 'preferences' },
      {
        path: 'preferences',
        component: UserPreferencesComponent,
        canActivate: [AuiUserRegisteredGuard],
      },
      { path: 'join/:token',
        canActivate: [AuiUserAuthenticatedGuard],
        component: UserJoinOrgComponent },
      { path: 'join',
        canActivate: [AuiUserAuthenticatedGuard],
        component: UserJoinOrgComponent },
    ],
  },
];

/**
 * Module for login routing
 */
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UserRoutingModule {}
